import React, { Component } from "react";
// 接口以及调用接口方法
import { queryTicketNumAndHours } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// icon
import { ArrowUpOutlined, ArrowDownOutlined, RightOutlined } from "@ant-design/icons";
// 组件

import PeoplePieChart from "@/pages/displayBoard/peoplePieChart";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class PeopleTicketCount extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      pieData:[],
      param: {
        isHourDetail:1,
        cityIds: this.props.param.cityIds,
        isMonth: this.props.param.isMonth,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      queryDate1: {
        totalNum: 0, // 工单总数
        totalHour: 0, // 工单总工时
        averageHour: 0, // 单工单平均工时
        priorityNameList: [], // 工单等级统计
      },
    };
  }

  // 页面加载前获取数据
  componentWillMount() {
    this.getEventMonitoringQry();
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.isMonth === this.state.param.isMonth
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      // console.log("一样");
    } else {
      this.setState(
        {
          param: {
            isHourDetail:1,
            cityIds: nextProps.param.cityIds,
            isMonth: nextProps.param.isMonth,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          this.getEventMonitoringQry();
        },
      );
    }
  }

  // 获取数据
  getEventMonitoringQry() {
    fetchHandler(queryTicketNumAndHours, {
      startTime: this.state.param.date,
      isMonth: this.state.param.isMonth,
      endTime:this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      // operationProperty: this.state.param.operationProperty,
      isHourDetail:1,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      if (res.data) {


        
        //按照工单等级进行分组合并，用于饼图、柱状图和下面的人员数据展示  后台返回的是列表数据，列表是根据人员和工单类型分组的。
        var map = {};
        var pieList = [];
        var colors = ['#40A9FF', '#FA8C16', '#CE0000', '#6A6AFF', '#64A600', '#FFFF6F'];
        var totalNum = 0;
        for(var i = 0; i < res.data.priorityNameList.length; i++){
          var ai = res.data.priorityNameList[i];
          totalNum += ai.totalNum;
          if(!map[ai.ticketPriorityId]){
            map[ai.ticketPriorityId] = {
              ticketPriorityId: ai.ticketPriorityId,
              ticketPriorityName: ai.ticketPriorityName,
              totalNum:ai.totalNum,
              totalHour:ai.totalHour
            };
          }else{
            map[ai.ticketPriorityId].totalNum = map[ai.ticketPriorityId].totalNum + ai.totalNum
          }
        }
        if (map != null)
        {
          var i = 0;
          for (var key in map) {
            map[key].rate = (map[key].totalNum / totalNum * 100).toFixed(2);
            map[key].color = colors[i];
            i++;
            pieList.push(map[key]);
          }
        }


        this.setState({
          pieData:pieList,
          queryDate1: {
            totalNum: res.data.totalNum, // 工单总数
            totalHour: res.data.totalHour, // 工单总工时
            averageHour: res.data.averageHour, // 单工单平均工时
            priorityNameList: res.data.priorityNameList, // 工单等级统计
          },
        });
      }
    });
  }


  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(null, e);
  };

  // 数据展示箭头样式设置
  formatterClassBorad = (value) => {
    let className = "";
    if (value === 0) {
      className = "item-rate none";
    } else if (value > 0) {
      className = "down-out-line item-rate";
    } else {
      className = "down-up-line item-rate";
    }
    return className;
  }

  render() {
    const content = (
      <div className="board-inner">
        <div className="order-part ">
          <div className="order-item">
            
            <div className="item-title">工单总数</div>
            <div className="item-num">{this.state.queryDate1.totalNum}</div>
            
          </div>
          <div className="order-item">
            <div className="item-title">工单总工时</div>
            <div className="item-num">{this.state.queryDate1.totalHour}</div>
            
          </div>
          <div className="order-item">
            <div className="item-title">单工单平均工时</div>
            <div className="item-num">{this.state.queryDate1.averageHour}</div>
            
          </div>
        </div>

        <div className="pie-chart" style={{display:'flex',     justifyContent: 'center'}}>
          <PeoplePieChart chartId="gllaaalPie" pieType="1" param={this.state.pieData} />
        </div>
      </div>
    );

    return content;
  }
}

export default injectIntl(PeopleTicketCount);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/peopleTicketCount.js